import React from "react";

import "./download-app.m.css";

const DownloadApp = () => {
  return (
    <div styleName="section">
      <div styleName="section-wrapper">
        <div styleName="left-content">
          <h1 styleName="primary-heading">
            Hooray! Our app is available to download now
          </h1>
          <h3 styleName="primary-description">
            Yup, you read it right. Our app is finally available to download. A
            big thank you to all our subscribers who contributed to make the app
            possible. Shoutout to all the readers who tested the app and helped
            us make it better.
          </h3>
          <div styleName="download-cta-div">
            <a
              href="https://apps.apple.com/in/app/newslaundry/id1609227019?mt=8"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src="https://images.assettype.com/newslaundry/2022-05/13b3de80-f642-4a15-be70-874855d17ba4/512x512.png"
                alt="google play store button"
              />
            </a>
            <a
              href="https://play.google.com/store/apps/details?id=com.newslaundry.android.app"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src="https://images.assettype.com/newslaundry/2022-05/c4d901fe-bf33-4d3a-b720-58c2182a8e9c/512x512.png"
                alt="app store button"
              />
            </a>
          </div>
          <p styleName="helper-text">
            Native podcast player, in-app subscriptions, gift subscription,
            ad-free, personalised notifications, bookmark, dark mode...we got it
            all. What are you waiting for? Click on the links above to download
            the app. For feedback and bugs, write to{" "}
            <a
              style={{ color: "var(--primary-color)" }}
              href="mailto:subscription@newslaundry.com"
            >
              subscription@newslaundry.com
            </a>
          </p>
        </div>
        <div styleName="right-content">
          <div styleName="image-wrapper">
            <img
              src="https://images.assettype.com/newslaundry/2022-05/b80947fb-36c4-434d-afac-a5d6bfc63b72/vertical_banner_new.jpg"
              alt="download app banner"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export { DownloadApp };
